import React from 'react';
import { Card, Grid } from "@mui/material";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import styled from '@emotion/styled';

const Article = styled.article`
  color: white;
`;

const Header = styled.header`
  margin-bottom: 2rem;
  text-align: center;
`;

const Section = styled.section`
  margin-bottom: 2rem;
`;

const Paragraph = styled.p`
  color: #fff;
  font-size: 1rem;
  margin-bottom: 1.5rem;
  line-height: 1.6;
`;

const Heading = styled.h2`
  color: #fff;
  font-size: 1.25rem;
  margin-bottom: 1rem;
  font-weight: 500;
`;

const List = styled.ul`
  color: #fff;
  font-size: 1rem;
  margin-left: 2rem;
  margin-bottom: 1.5rem;
  line-height: 1.6;
`;

const ListItem = styled.li`
  margin-bottom: 0.5rem;
`;

const Address = styled.address`
  color: #fff;
  font-size: 1rem;
  line-height: 1.6;
  font-style: normal;
`;

const Link = styled.a`
  color: #1976d2;
  text-decoration: none;
`;

const Divider = styled.hr`
  border: none;
  height: 1px;
  background: rgba(255, 255, 255, 0.1);
  margin: 2rem 0;
`;

const EULAPage = () => {
  return (
    <VuiBox py={3}>
      <Grid container justifyContent="center" alignItems="center">
        <Grid item xs={12} md={8}>
          <Card>
            <VuiBox p={3}>
              <Article>
                <Header>
                  <VuiTypography variant="h3" color="white" fontWeight="bold" mb={2}>
                    END USER LICENSE AGREEMENT (EULA) FOR DIGIMENTOR
                  </VuiTypography>
                  <VuiTypography variant="button" color="text">
                    Last Updated: 7/1/25
                  </VuiTypography>
                </Header>

                <Divider />

                <Section>
                  <Paragraph>
                    PLEASE READ THIS END USER LICENSE AGREEMENT ("AGREEMENT") CAREFULLY
                    BEFORE USING THE DIGIMENTOR WEB APPLICATION ("APP"). BY ACCESSING OR
                    USING THE APP, YOU AGREE TO BE BOUND BY THIS AGREEMENT. IF YOU DO NOT
                    AGREE, DO NOT USE THE APP.
                  </Paragraph>
                </Section>

                <Divider />

                <Section>
                  <Heading>
                    1. LICENSE
                  </Heading>
                  <Paragraph>
                    Subject to your compliance with this Agreement, <strong>Daily Mentor PTY LTD</strong> ("Licensor," "we," "our,"
                    or "us") grants you a limited, non-exclusive, non-transferable, revocable license to access and
                    use DigiMentor for your internal business or personal purposes in accordance with this
                    Agreement.
                  </Paragraph>
                </Section>

                <Divider />

                <Section>
                  <Heading>
                    2. RESTRICTIONS
                  </Heading>
                  <Paragraph>
                    You agree that you will NOT:
                  </Paragraph>
                  <List>
                    <ListItem>Copy, modify, adapt, or create derivative works of the App.</ListItem>
                    <ListItem>Reverse engineer, decompile, or attempt to discover the source code.</ListItem>
                    <ListItem>Sell, rent, sublicense, distribute, or commercially exploit the App except as expressly permitted.</ListItem>
                    <ListItem>Use the App for any unlawful, harmful, or fraudulent purpose.</ListItem>
                    <ListItem>Interfere with or disrupt the App's functionality or security.</ListItem>
                  </List>
                </Section>

                <Divider />

                <Section>
                  <Heading>
                    3. OWNERSHIP
                  </Heading>
                  <Paragraph>
                    The App is licensed, not sold. All rights, title, and interest in and to the App (including all
                    intellectual property rights) remain with <strong>Daily Mentor PTY LTD</strong> and its licensors. Nothing in this
                    Agreement grants you ownership rights in the App.
                  </Paragraph>
                </Section>

                <Divider />

                <Section>
                  <Heading>
                    4. ACCESS AND AVAILABILITY
                  </Heading>
                  <Paragraph>
                    We may modify, suspend, or discontinue all or part of the App at any time without notice. We are
                    not liable if the App is unavailable or modified.
                  </Paragraph>
                </Section>

                <Divider />

                <Section>
                  <Heading>
                    5. PRIVACY
                  </Heading>
                  <Paragraph>
                    Your use of the App is subject to our Privacy Policy, which explains how we collect, use, and
                    protect your personal data. By using the App, you consent to our collection and use of personal
                    information as described in the Privacy Policy.
                  </Paragraph>
                </Section>

                <Divider />

                <Section>
                  <Heading>
                    6. USER ACCOUNTS
                  </Heading>
                  <Paragraph>
                    You may need to create an account to use certain features. You are responsible for maintaining
                    the confidentiality of your account credentials and for all activities under your account. You
                    agree to notify us immediately of any unauthorised use of your account.
                  </Paragraph>
                </Section>

                <Divider />

                <Section>
                  <Heading>
                    7. TERMINATION
                  </Heading>
                  <Paragraph>
                    We may suspend or terminate your access to the App at any time for any reason, including if
                    you violate this Agreement. Upon termination, your right to use the App will immediately cease.
                  </Paragraph>
                </Section>

                <Divider />

                <Section>
                  <Heading>
                    8. DISCLAIMER OF WARRANTIES
                  </Heading>
                  <Paragraph>
                    THE APP IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY
                    KIND, WHETHER EXPRESS OR IMPLIED, INCLUDING WARRANTIES OF
                    MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT.
                    WE DO NOT WARRANT THAT THE APP WILL BE UNINTERRUPTED, ERROR-FREE, OR
                    SECURE.
                  </Paragraph>
                </Section>

                <Divider />

                <Section>
                  <Heading>
                    9. LIMITATION OF LIABILITY
                  </Heading>
                  <Paragraph>
                    TO THE MAXIMUM EXTENT PERMITTED BY LAW, <strong>Daily Mentor PTY LTD</strong> WILL NOT BE
                    LIABLE FOR ANY INDIRECT, INCIDENTAL, CONSEQUENTIAL, SPECIAL, OR EXEMPLARY
                    DAMAGES ARISING OUT OF OR IN CONNECTION WITH YOUR USE OF THE APP. OUR
                    TOTAL LIABILITY FOR ALL CLAIMS RELATING TO THE APP WILL NOT EXCEED AUD $100.
                  </Paragraph>
                </Section>

                <Divider />

                <Section>
                  <Heading>
                    10. GOVERNING LAW
                  </Heading>
                  <Paragraph>
                    This Agreement is governed by the laws of South Australia and the Commonwealth of Australia.
                    You agree to submit to the exclusive jurisdiction of the courts located in South Australia.
                  </Paragraph>
                </Section>

                <Divider />

                <Section>
                  <Heading>
                    11. CHANGES TO THIS AGREEMENT
                  </Heading>
                  <Paragraph>
                    We may update this Agreement from time to time. If we make material changes, we will provide
                    notice by updating the date at the top of this Agreement and may provide additional notice. Your
                    continued use of the App after any changes constitutes your acceptance of the revised
                    Agreement.
                  </Paragraph>
                </Section>

                <Divider />

                <Section>
                  <Heading>
                    12. CONTACT
                  </Heading>
                  <Paragraph>
                    If you have any questions about this Agreement, please contact us at:
                  </Paragraph>
                  <Address>
                    <strong>Daily Mentor PTY LTD</strong><br />
                    39 Orsmond Street<br />
                    Hindmarsh, SA, 5007<br />
                    Australia<br /><br />
                    Email: <Link href="mailto:membership@dailymentor.co">membership@dailymentor.co</Link><br />
                    Website: <Link href="https://dailymentor.co">https://dailymentor.co</Link>
                  </Address>
                </Section>
              </Article>
            </VuiBox>
          </Card>
        </Grid>
      </Grid>
    </VuiBox>
  );
};

export default EULAPage; 